import { ProjectShowcase } from "components/showcases/ProjectShowcase"
import { useProjects } from "hooks/useProjects"
import "./ProjectsWrapper.scss"

export const ProjectsWrapper = () => {
    const { projects, loading, error } = useProjects()

    if (loading) {
        return <p>Loading projects...</p>
    }
    if (error !== null) {
        return <p>There was an error meanwhile we are loading the projects.</p>
    }

    if (!loading && projects.length === 0) {
        return <p>I'm so sorry. There aren't projects to show. Please, try again.</p>
    }

    return (
        <div className="projectswrapper">
            {
                projects.map(project => {
                    return (
                        <ProjectShowcase
                            key={project.id}
                            project={project}
                        />
                    )
                })
            }
        </div>
    )
}